import type { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import {
  faChrome,
  faEdge,
  faFirefox,
  faInternetExplorer,
  faOpera,
  faSafari,
  faYahoo,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { Chip } from '@feathr/components';

enum Browsers {
  chrome = 'Chrome',
  edge = 'Edge',
  firefox = 'Firefox',
  msie = 'Internet Explorer',
  opera = 'Opera',
  safari = 'Safari',
  yahoo = 'Yahoo',
}

export interface IProps {
  browser: keyof typeof Browsers;
}

const IconMap: Record<keyof typeof Browsers, IconDefinition> = {
  msie: faInternetExplorer,
  edge: faEdge,
  chrome: faChrome,
  firefox: faFirefox,
  safari: faSafari,
  opera: faOpera,
  yahoo: faYahoo,
};

function BrowserChip({ browser }: IProps) {
  const browserIcon = IconMap[browser];

  return (
    <Chip prefix={browserIcon ? <FontAwesomeIcon icon={browserIcon} /> : undefined}>
      {Browsers[browser] || 'Other'}
    </Chip>
  );
}

export default observer(BrowserChip);
